import { useState , useEffect} from 'react';
import axios from 'axios';

export const useFetchFacility = () => {
    const [facilityList, setFacilityList] = useState([]);
    const [isFacilityLoading , setIsLoading] = useState(false);
    
    useEffect(() => {
        const fetchRequest = async ()  =>{
            setIsLoading(true);

            //JSON取得
            axios.get('/assets/json/facilityData.json?'+(new Date()).getTime())
                .then(res => {
                    const data = JSON.parse(JSON.stringify(res.data));
                    setFacilityList(data.list);
                })
                //.catch(() => setIsError(true))
                .finally(() => setIsLoading(false));
        }
        fetchRequest();
    }, []); 

    return {facilityList , isFacilityLoading };
}
